import { withBemMod } from '@bem-react/core';
import React, { Fragment, useContext } from 'react';

import HtmlContent from 'client/common/components/html-content';
import { ConfigContext } from 'client/common/contexts';
import { ILevelMedia } from 'client/common/types';

import { b, ILevelProps } from '..';

import './level_type_media.css';

export interface ILevelMediaProps extends Omit<ILevelMedia, 'type'> {
    type?: 'media';
}

function constructNElements(n: number, Element: React.FC<{}>) {
    const elements = [];

    for (let i = 0; i < n; i++) {
        elements.push(<Element key={i} />);
    }

    return elements;
}

export const withLevelTypeMedia = withBemMod<ILevelMediaProps, ILevelProps>(
    b(),
    { type: 'media' },
    (BaseLevel: React.FC<ILevelProps>) => props => {

        const { imageStyle, caption: generalCaption, blocks, ...otherProps } = props;

        const blocksLength = blocks.length;

        const header: string[] = [];
        const body: Array<string | undefined> = [];
        const captions: string[] = [];
        const footer: string[] = [];

        blocks.forEach(({ topText, image, caption, bottomText }) => {
            header.push(topText || '');
            body.push(image);
            captions.push(caption || '');
            footer.push(bottomText || '');
        });

        const scrollableMod = { scrollable: blocksLength > 1 };
        const sizeMod = { size: blocksLength };

        const { uatraits } = useContext(ConfigContext);
        const { width = 0, height = 0 } = imageStyle || {};
        const style = !uatraits.isMobile && blocksLength === 1 ? {
            width: width || (height ? 'auto' : '100%'),
            height: height || (width ? 'auto' : undefined)
        } : {};

        /* eslint-disable react/no-array-index-key */
        return (
            <BaseLevel {...otherProps}>
                <Fragment>
                    {blocksLength >= 1 && (
                    <div className={b('content', scrollableMod)}>
                        <div className={b('blocks', sizeMod)}>
                            <div className={b('columns', sizeMod)}>
                                {constructNElements(
                                    blocksLength, () => <div className={b('column')} />
                                )}
                            </div>
                            <div className={b('blocks-header')}>
                                <div className={b('row')}>
                                    {header.map((topText, id) => (
                                        <HtmlContent
                                            key={id}
                                            className={b('top-text')}
                                            content={topText}
                                            />
                                    ))}
                                </div>
                            </div>
                            <div className={b('blocks-body')}>
                                <div className={b('row')}>
                                    {body.map((imageSrc, id) => (
                                        <div key={id} className={b('image')}>
                                            {imageSrc && <img src={imageSrc} style={style} />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={b('blocks-footer')}>
                                <div className={b('row')}>
                                    {captions.map((caption, id) => (
                                        <HtmlContent
                                            key={id}
                                            className={b('caption')}
                                            content={caption}
                                            />
                                    ))}
                                </div>
                                <div className={b('row')}>
                                    {footer.map((bottomText, id) => (
                                        <HtmlContent
                                            key={id}
                                            className={b('bottom-text')}
                                            content={bottomText}
                                            />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>)}
                    {generalCaption && <HtmlContent className={b('caption')} content={generalCaption} />}
                </Fragment>
            </BaseLevel>
        );
    }
);
